import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import SelectableOptionsList from './SelectableOptionsList';

const ITEMS = [
  { id: 'a', label: 'Account A' },
  { id: 'b', label: 'Account B' },
];

const renderList = (props = {}) =>
  render(
    <ConfigProvider>
      <SelectableOptionsList
        multiple
        items={ITEMS}
        pointerEvents="auto"
        selected={[]}
        onChange={() => {}}
        {...props}
      />
    </ConfigProvider>,
  );

const rowFor = (container, id) =>
  container.querySelector(`li[data-id="${id}"]`);

describe('management/Users SelectableOptionsList', () => {
  it('renders the options it is handed', () => {
    const { container } = renderList();

    expect(rowFor(container, 'a')).toBeInTheDocument();
    expect(rowFor(container, 'b')).toBeInTheDocument();
  });

  it('reports a click on a row label', () => {
    const onChange = jest.fn();

    renderList({ onChange });
    fireEvent.click(screen.getByText('Account A'));

    expect(onChange).toHaveBeenCalledWith(['a']);
  });

  // The bug this component exists for: OptionsList wraps the row, checkbox
  // included, in a <label> and hangs the click handler off the <li>, so a click
  // on the row's text arrived twice — once as itself and once as the click the
  // <label> forwarded to the checkbox — and the two toggles cancelled out.
  it('lets a label click reach the row only once', () => {
    const { container } = renderList();
    const row = rowFor(container, 'a');

    let clicks = 0;
    row.addEventListener('click', () => {
      clicks += 1;
    });

    fireEvent.click(screen.getByText('Account A'));

    expect(clicks).toEqual(1);
  });

  // And the other half: the checkbox must keep working. Its own label stops
  // propagation, so the forwarded click is the only one that reaches the row —
  // cancel that and the checkbox goes dead, which is how the first cut of this
  // fix shipped and was caught in QA.
  it('still reports a click on the checkbox', () => {
    const onChange = jest.fn();
    const { container } = renderList({ onChange });

    fireEvent.click(rowFor(container, 'a').querySelector('label[for]'));

    expect(onChange).toHaveBeenCalledWith(['a']);
  });

  it('still reports a click on the checkbox input itself', () => {
    const onChange = jest.fn();
    const { container } = renderList({ onChange });

    fireEvent.click(
      rowFor(container, 'a').querySelector('input[type="checkbox"]'),
    );

    expect(onChange).toHaveBeenCalledWith(['a']);
  });
});
